/** RequireAuth.tsx — route guard; redirects to /login when unauthenticated. */

import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuthStore } from '@/auth/store';

export function RequireAuth({ children }: { children: ReactNode }) {
  const authed = useAuthStore((s) => Boolean(s.access || s.refresh));
  const location = useLocation();
  if (!authed) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
